import type { Card } from '../../../domain/Card'
import type { CardDTO } from '../../../domain/CardDTO'
import { ContentModelId } from '../../../../../types/ContentModelId'

import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'

export const mapCardFromApi = (dto: CardDTO): Card | undefined => {
  if (!isNonNullableEntryDTO(dto)) {
    return undefined
  }

  const { buttonLabel, description, icon, iconName, image, size, title, url } = dto.fields

  return {
    buttonLabel,
    contentType: ContentModelId.CARD,
    description,
    icon,
    iconName,
    image: image?.fields,
    size,
    title,
    url,
  }
}
